import React from 'react';
import { Hero } from './components/Hero';
import { ForYou } from './components/ForYou';
import { ProblemSection } from './components/ProblemSection';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Projects } from './components/Projects';
import { Testimonials } from './components/Testimonials';
import { OfferCard } from './components/OfferCard';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
import { useCountdown } from './hooks/useCountdown';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
interface AppProps {
  /** Show the placeholder countdown above the offer card. */
  showCountdown?: boolean;
}
export function App({
  showCountdown = true
}: AppProps) {
  const countdown = useCountdown(30);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="23utcq6luo6cd">
      <MetaPixel data-id="element-1" data-mp="3ikh8gaq64uzi" />
      <PurchasePopup data-id="element-2" data-mp="3iiwdijzxza14" />
      <Hero countdown={countdown} data-id="element-3" data-mp="3ijfv1zlojwem" />
      <main data-id="element-4" data-mp="3mlj9mx3nbh44">
        <ForYou data-id="element-5" data-mp="3mlax56bfqdtg" />
        <ProblemSection data-id="element-6" data-mp="3mkrc3gqhn9b7" />
        <Modules data-id="element-7" data-mp="3mjzs7369700r" />
        <Projects data-id="element-8" data-mp="3mjgannkimdn9" />
        <Bonuses data-id="element-9" data-mp="3rc9e8848zfxr" />
        <Testimonials data-id="element-10" data-mp="3rbrakqf99zft" />
        <OfferCard showCountdown={showCountdown} countdown={countdown} data-id="element-11" data-mp="3rdatkosaqola" />
        <Faq data-id="element-12" data-mp="6hrlipoilfp" />
        <FinalCta data-id="element-13" data-mp="682dxcgkib2" />
      </main>
      <SiteFooter data-id="element-14" data-mp="56ntiw8hdol" />
    </div>;
}